import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[ng-typehead-input-option-tmp]', standalone: true })
export class NgTypeheadInputOptionTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({ selector: '[ng-typehead-input-label-tmp]', standalone: true })
export class NgTypeheadInputLabelTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({ selector: '[ng-typehead-input-group-tmp]', standalone: true })
export class NgTypeheadInputGroupTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({ selector: '[ng-typehead-input-field-label-tmp]', standalone: true })
export class NgTypeheadInputFieldLabelTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({ selector: '[ng-typehead-input-footer-tmp]', standalone: true })
export class NgTypeheadInputFooterTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({ selector: '[ng-select-input-option-tmp]', standalone: true })
export class NgSelectInputOptionTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({ selector: '[ng-select-input-label-tmp]', standalone: true })
export class NgSelectInputLabelTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({ selector: '[ng-date-button-input-trigger-tmp]', standalone: true })
export class NgDateButtonInputTriggerTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({ selector: '[ng-checkbox--input-label-tmp]', standalone: true })
export class NgCheckboxInputLabelTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}
